var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenucopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13H1a1 1 0 110-2h22a1 1 0 110 2zm0-7H12a1 1 0 110-2h11a1 1 0 110 2zM12 20H1a1 1 0 110-2h11a1 1 0 110 2z",
    fill: "#FBFBFB"
  })));
}

export default SvgMenucopy;